import type { RelaunchDiffusionForProductMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { partenaires } from '~/msw/mocks/diffusion'

export function relaunchDiffusionForProductHandler() {
  return http.post<
    { annonceId: string, codeProduit: string },
    never,
    RelaunchDiffusionForProductMutationResponse
  >('http://localhost:3000/api/v1/diffusions/:annonceId/relancer/:codeProduit', ({ params }) => {
    const produit = partenaires.find(p => p.code === params.codeProduit)?.label ?? params.codeProduit
    return HttpResponse.json({
      produit,
      success: true,
      message: 'Annonce relancée avec succès',
    })
  })
}

// Variante « scenario » de l'endpoint : la relance d'un produit échoue (HTTP 500).
// Branchée via ?scenario=relaunchError et composée dans ~/msw/scenarios.ts.
export function relaunchDiffusionForProductErrorHandler() {
  return http.post(
    'http://localhost:3000/api/v1/diffusions/:annonceId/relancer/:codeProduit',
    () => HttpResponse.json({ message: 'Échec de la relance' }, { status: 500 }),
  )
}
